module.exports = __webpack_public_path__ + "static/media/handshake.c12db402.png";